import React from 'react';
import PropTypes from 'prop-types';
import Test from './Test';
import './style.scss';

export default function SkillTests({ tests, biData }) {
    if (!tests.length) { return null; }

    return (
        <div className="skill-tests">
            <h3>
                {i18n.t('seller_profile.skill_tests')}
                <span>{i18n.t('seller_profile.beta')}</span>
            </h3>
            <ul>
                {tests.map((test, idx) => <Test {...test} biData={biData} key={idx}/>)}
            </ul>
        </div>
    );
}

SkillTests.propTypes = {
    tests: PropTypes.array,
    biData: PropTypes.object
};

SkillTests.defaultProps = {
    tests: [],
    biData: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/SkillTests/index.js